import {HIDE_ALERT} from "../../../constants/LiveConstants";
import {GeneralAction, HideLivePayload} from "../../../@types/actions";

export const HideAlertAction = (data: HideLivePayload): GeneralAction<HideLivePayload> => ({
    type: HIDE_ALERT,
    payload: data
});
